// @ts-nocheck
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { ClickableProps } from "@insite/mobius/Clickable";
import { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
import { StoreHistoryFilterProps } from "@store/Themes/common/props/filters";
import { formGridProps } from "@store/Themes/common/props/form";
import { tableGetEllipsisCellProps, tableProps } from "@store/Themes/common/props/table";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
import { css } from "styled-components";

export interface HistoryFilterProps {
    wrapper?: InjectableCss;
    clearButton?: ButtonPresentationProps;
    tagWrapper?: TagWrapperProps;
}

export const historyFilterProps: HistoryFilterProps = {
    wrapper: {},
    clearButton: { variant: "secondary" },
    tagWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    ${x => spacingStyles(x.theme.design.typography.spacing.base, null)}
                `,
            },
        },
    },
};

export const historyFilterPropsAlt: StoreHistoryFilterProps = {
    gridContainer: formGridProps.gridContainer,
    gridItem: { width: [12, 6, 12, 6, 6] },
    subGridItem: { width: [12, 6, 6, 3, 3] },
    applyButton: {
        variant: "primary",
    },
    clearButton: {
        variant: "secondary",
    },
};

export interface HistoryTableProps {
    loadingOverlay?: LoadingOverlayProps;
    container?: InjectableCss;
    wrapper?: InjectableCss;
    noResultsText?: TypographyProps;
    dataTable?: DataTableProps;
    headingWrapper?: FlexWrapperPresentationProps;
    checkboxHeader?: DataTableHeaderProps;
    checkboxCell?: DataTableCellProps;
    orderNumberHeader?: DataTableHeaderProps;
    orderNumberCell?: DataTableCellProps;
    dateHeader?: DataTableHeaderProps;
    dateCell?: DataTableCellProps;
    shipToHeader?: DataTableHeaderProps;
    shipToCell?: DataTableCellProps;
    customerPOHeader?: DataTableHeaderProps;
    customerPOCell?: DataTableCellProps;
    statusHeader?: DataTableHeaderProps;
    statusCell?: DataTableCellProps;
    totalHeader?: DataTableHeaderProps;
    totalCell?: DataTableCellProps;
    buttonHeader?: DataTableHeaderProps;
    buttonCell?: DataTableCellProps;
    button?: ButtonPresentationProps;
}

export const historyTableProps: HistoryTableProps = {
    loadingOverlay: {
        css: css`
            min-height: 150;
        `,
    },
    container: {
        css: css`
            ${x => spacingStyles(x.theme.design.typography.spacing.large, null)}
        `,
    },

    wrapper: tableProps.wrapper,
    noResultsText: typographyGetNoResultsAltProps({ spaced: true }),
    dataTable: tableProps.dataTable,
    headingWrapper: {
        gap: pxToRem(16),
        verticalGap: pxToRem(8),
        extendedStyles: {
            wrapper: resultCountProps.wrapper,
            content: {
                css: css`
                    justify-content: space-between;
                `,
            },
        },
    },
    checkboxHeader: tableProps.selectionCell,
    checkboxCell: tableProps.selectionCell,
    orderNumberHeader: {},
    orderNumberCell: {
        css: css`
            span {
                font-weight: ${props => props.theme.design.typography.weight.bold};
            }
        `,
    },
    dateHeader: {},
    dateCell: {},
    shipToHeader: {
        tight: true,
    },
    shipToCell: {
        css: css`
            position: relative;
        `,
        typographyProps: {
            ellipsis: true,
            css: css`
                position: absolute;
                width: 85%;
                overflow: hidden;
                top: 50%;
                transform: translateY(-50%);
                text-overflow: ellipsis;
                white-space: nowrap;
                display: block;
            `,
        },
    },
    customerPOHeader: {},
    customerPOCell: tableGetEllipsisCellProps(95),
    statusHeader: {},
    statusCell: tableGetEllipsisCellProps(95),
    totalHeader: tableProps.amountHeader,
    totalCell: tableProps.amountCell,
    buttonHeader: tableProps.buttonHeader,
    buttonCell: tableProps.buttonCell,
    button: tableProps.button,
};
